import {createTheme} from "@mui/material";

import '@fontsource/lexend/300.css';
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';
import '@fontsource/lexend/600.css';
import '@fontsource/lexend/700.css';

export const customBackOfficeTheme = createTheme({
  typography: {
    fontFamily: 'Lexend',
  },
});